import Device from '@/app/components/search/Janus/utils/device.ts';
import type { CommonData } from '@/app/common/createCommonData.ts';
import { clientAppLog } from '@/app/components/search/logging/clientAppLog.ts';
import type { SearchInfoData } from '@/app/search/types.ts';
import { SearchModes } from '@/domainLogic/index.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';

export const updateCommonDataByDevice = (commonData: CommonData): CommonData => {
  const device = new Device(commonData.UA);
  const { isIpad } = device;
  const deviceType = device.getDeviceType();

  return deviceType !== commonData.deviceType && isIpad
    ? {
        ...commonData,
        deviceType,
        isIpad,
        isMobileDevice: deviceType === 'mobile',
        isTabletDevice: deviceType === 'tablet',
        isDesktopDevice: deviceType === 'desktop',
      }
    : commonData;
};

// HandleUserChangedLanguagePayload and BusinessProfileKinds types defined by Content Hub
type BusinessProfileKinds = {
  dp?: string;
  flight?: string;
  hotel?: string;
  train?: string;
  trainHotel?: string;
};
type HandleUserChangedLanguagePayload = {
  businessProfileKinds: BusinessProfileKinds;
  country: string;
  countryCode: string;
  currency: string;
  languageCode: string;
  url: string;
};

type CreateHandleUserChangedLanguageProps = {
  searchInfoData: SearchInfoData;
};
export const createHandleUserChangedLanguage = ({ searchInfoData }: CreateHandleUserChangedLanguageProps) => {
  const { searchMode } = searchInfoData;
  const getNewBusinessProfile = (businessProfileKinds: BusinessProfileKinds) => {
    if (searchMode === SearchModes.HO) return businessProfileKinds?.hotel;
    if (searchMode === SearchModes.DP) return businessProfileKinds?.dp;
    if (searchMode === SearchModes.TH) return businessProfileKinds?.trainHotel;
    return undefined;
  };

  return ({
    businessProfileKinds,
    country,
    countryCode,
    currency,
    languageCode,
    url,
  }: HandleUserChangedLanguagePayload) => {
    const newBusinessProfile = getNewBusinessProfile(businessProfileKinds);
    const payloadString = JSON.stringify({
      businessProfileKinds,
      country,
      countryCode,
      currency,
      languageCode,
      url,
    });

    clientAppLog({
      level: 'INFO',
      codeSourceName: 'pageWrapperClientUtils handleUserChangedLanguage',
      logMessage: `payload:${payloadString}, newBusinessProfile: ${newBusinessProfile}`,
      url: window.location.href,
    });

    if (newBusinessProfile) {
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set(URLParameters.BUSINESS_PROFILE_ID, newBusinessProfile);
      window.location.href = newUrl.toString();
    } else {
      clientAppLog({
        level: 'WARN',
        codeSourceName: 'pageWrapperClientUtils handleUserChangedLanguage',
        logMessage: `No new Business Profile. Not redirecting. payload:${payloadString}`,
        url: window.location.href,
      });
    }
  };
};
